import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Trophy, TrendingUp } from 'lucide-react';

const Career = () => {
  const { t } = useLanguage();

  const clubs = [
    {
      name: t.career.cobreloa.name,
      country: t.career.cobreloa.country,
      description: t.career.cobreloa.description,
      icon: Trophy,
      color: 'orange'
    },
    {
      name: t.career.fortaleza.name,
      country: t.career.fortaleza.country,
      description: t.career.fortaleza.description,
      icon: TrendingUp,
      color: 'blue'
    },
    {
      name: t.career.udec.name,
      country: t.career.udec.country,
      description: t.career.udec.description,
      icon: TrendingUp,
      color: 'yellow'
    }
  ];

  return (
    <section id="career" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold mb-4 tracking-wide"
            style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          >
            {t.career.title}
          </h2>
          <div className="h-1 w-20 bg-red-600 mx-auto mb-4" />
          <p className="text-gray-400 text-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t.career.subtitle}
          </p>
        </div>

        {/* Clubs */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {clubs.map((club, index) => {
            const Icon = club.icon;
            return (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:border-red-600/50 transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-2xl"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-red-600/10 p-4 rounded-xl">
                    <Icon className="text-red-600" size={32} />
                  </div>
                  <div className="flex-1">
                    <h3
                      className="text-3xl font-bold mb-2"
                      style={{ fontFamily: 'Oswald, sans-serif' }}
                    >
                      {club.name}
                    </h3>
                    <p className="text-gray-400 mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {club.country}
                    </p>
                    <p className="text-gray-300 text-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {club.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Career;
